module.exports = __webpack_public_path__ + "media/images/flags/eo-a059da791d22d2289a1875c72742babb.svg";